import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../common/_common.scss'
import AdviserProfileConflictDeclarations from '../../../common/AdviserProfiles/AdviserProfileConflictDeclarations'
import * as styles from './_AdviserProfileConflictDeclarationsEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { actions } from './adviserProfileConflictDeclarationsEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileConflictDeclarationsEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingDeclarations: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingDeclarations: PropTypes.func.isRequired,
    stopEditingDeclarations: PropTypes.func.isRequired,
    cancelEditingDeclarations: PropTypes.func.isRequired,
    fetchConflictDeclarations: PropTypes.func.isRequired,
    allDeclarations: PropTypes.array.isRequired,
    conflictDeclarationSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    setIsIndependent: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props)
    this.stopEditingConflictDeclarations = this.stopEditingConflictDeclarations.bind(this)
    this.state = {
      noConflict: true
    }
  }

  componentDidMount () {
    this.props.fetchConflictDeclarations()
  }

  stopEditingConflictDeclarations () {
    this.props.stopEditingDeclarations()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profile.conflictDeclarations !== this.props.profile.conflictDeclarations ||
      prevProps.allDeclarations !== this.props.allDeclarations) {
      const { allDeclarations, profile } = this.props;
      let noConflictSelected = true;

      (allDeclarations || []).forEach(conflictDeclaration => {
        const selected = (profile.conflictDeclarations || []).some(
          d => d.conflictDeclarationId === conflictDeclaration.conflictDeclarationId
        );
        if (selected) noConflictSelected = false;
      });

      if (this.state.noConflict !== noConflictSelected) {
        this.setState({ noConflict: noConflictSelected });
      }
    }
  }

  render () {
    const { profile, editingDeclarations, submitting } = this.props

    if (editingDeclarations || submitting) {
      const allDeclarations = (this.props.allDeclarations || []).map(declaration => ({ ...declaration }))
      const selectedDeclarations = this.props.profile.conflictDeclarations || []
      var atLeastOnceConflictSelected = false
      allDeclarations.forEach((conflictDeclaration) => {
        var selected = false
        selectedDeclarations.forEach((selectedDeclaration) => {
          selected = selected || selectedDeclaration.conflictDeclarationId === conflictDeclaration.conflictDeclarationId
        })
        conflictDeclaration.selected = selected
        atLeastOnceConflictSelected = atLeastOnceConflictSelected || selected
      })

      return <div>
        <h4 className={styles['title']}>Conflict Declarations</h4>
        <p>Please indicate if any of the following potential conflicts of interest apply to you and/or your business. Your selections will be displayed on your Allan Gray profile.</p>
        <form className={styles['form-bottom-margin']}>
          {allDeclarations.map((conflictDeclaration) => {
            return <FormCheck
              key={conflictDeclaration.conflictDeclarationId}
              type="checkbox"
              checked={conflictDeclaration.selected}
              value={conflictDeclaration.conflictDeclarationId}
              onChange={() => {
                this.props.conflictDeclarationSelectedChanged(conflictDeclaration)
                if (!conflictDeclaration.selected) {
                  this.setState({ noConflict: false })
                }
              }}
              label={conflictDeclaration.description}
            />

          })}
          <FormCheck
            key={99}
            type="checkbox"
            checked={this.state.noConflict && !atLeastOnceConflictSelected}
            value={this.state.noConflict}
            onChange={() => {
              if (!this.state.noConflict) {
                this.props.setIsIndependent()
              }
              this.setState({ noConflict: !this.state.noConflict })
            }}
            label="None of the above apply to me or my business"
          />

        </form>
      </div>
    }

    return <div>
      <AdviserProfileConflictDeclarations conflictDeclarations={profile.conflictDeclarations || []} />
    </div>
  }
}

const mapStateToProps = (state) => {
  return {
    editingDeclarations: state.adviserProfileEditorContainer.conflictDeclarations.editingDeclarations,
    loading: state.adviserProfileEditorContainer.conflictDeclarations.loadingDeclarations,
    formIsValid: state.adviserProfileEditorContainer.conflictDeclarations.isInvalid.formIsValid,
    validationstate: state.adviserProfileEditorContainer.conflictDeclarations.isInvalid,
    submitting: state.adviserProfileEditorContainer.conflictDeclarations.submitting,
    allDeclarations: state.adviserProfileEditorContainer.conflictDeclarations.allDeclarations
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, fetch, set } = actions
  return bindActionCreators({
    startEditingDeclarations: edit.start,
    stopEditingDeclarations: edit.stop,
    cancelEditingDeclarations: edit.cancel,
    fetchConflictDeclarations: fetch.conflictDeclarations,
    conflictDeclarationSelectedChanged: set.selectionChanged,
    setIsIndependent: set.isIndependent
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileConflictDeclarationsEditorActions))
